import { useState } from "react";
import { toast } from "sonner";
import { MessageSquarePlus, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import api, { formatError } from "../lib/api";

export default function FeedbackBanner({ context = "app" }) {
  const [hidden, setHidden] = useState(() => localStorage.getItem("hyrox_fb_hidden") === "1");
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const dismiss = () => { localStorage.setItem("hyrox_fb_hidden", "1"); setHidden(true); };

  const send = async () => {
    if (!msg.trim()) return;
    setBusy(true);
    try {
      await api.post("/feedback", { message: msg.trim(), context });
      toast.success("Merci ! Ton retour a bien été envoyé 🙏");
      setMsg(""); setOpen(false);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  if (hidden) return null;

  return (
    <>
      <div data-testid="feedback-banner" className="flex items-center gap-3 bg-primary/10 border border-primary/30 rounded-lg px-4 py-2.5 mb-4">
        <MessageSquarePlus size={18} className="text-primary shrink-0" />
        <p className="text-sm text-foreground flex-1">Un souci ? Une idée ? Aide-nous à améliorer l'app.</p>
        <Button data-testid="feedback-open-btn" size="sm" onClick={() => setOpen(true)} className="bg-primary hover:bg-primary/90 text-white shrink-0">Donner mon avis</Button>
        <button data-testid="feedback-dismiss-btn" onClick={dismiss} className="text-muted-foreground hover:text-foreground shrink-0" title="Masquer"><X size={16} /></button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="feedback-dialog" aria-describedby="feedback-desc" className="max-w-md bg-card border-border">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">Ton retour</DialogTitle>
            <DialogDescription id="feedback-desc" className="text-muted-foreground">Bug, idée, remarque… tout nous intéresse pendant le bêta.</DialogDescription>
          </DialogHeader>
          <Textarea data-testid="feedback-textarea" rows={5} value={msg} onChange={(e) => setMsg(e.target.value)}
            placeholder="Écris ton message ici…" className="text-base bg-secondary border-border resize-none" />
          <Button data-testid="feedback-submit-btn" onClick={send} disabled={busy || !msg.trim()} className="bg-primary hover:bg-primary/90 text-white w-full h-11 font-semibold">
            {busy ? "Envoi…" : "Envoyer"}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
